import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { AssessmentCreateInput } from '../generated/globalTypes';
import { createAssessmentMutation, createAssessmentMutationVariables } from '../generated/createAssessmentMutation';
import { assessmentFieldsFragment } from '../models/Assessment';

/**
 * Get a callback to create a Assessment in the store.
 */
export function useCreateAssessmentCallback(): [(model: AssessmentCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createAssessmentMutation, createAssessmentMutationVariables>(
        gql`
            mutation createAssessmentMutation ($model: AssessmentCreateInput!) {
                createAssessment(model: $model) {
                    ...assessmentFields
                }
            }

            ${assessmentFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: AssessmentCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
